import { useState } from 'react'
import { useApp } from '../../../hooks/useApp'
import { formatCentsToDollars } from '../../../utils/formatCentsToDollars'
import { Button } from '../../ui/Button/Button'
import { Text } from '../../ui/Text/Text'
import { getMainProductVariantById, getPendantProductVariantById } from './utils'

interface Props {
  className?: string
}

export const ActiveProductVariantDescription = ({ className }: Props) => {
  const {
    mainProduct,
    activeScreen,
    activeMainProductVariantId,
    active,
    activePendantProductVaraintIds,
  } = useApp()
  const [moreOpen, setMoreOpen] = useState(false)

  const activeProductVariant = activeScreen === 'CHAIN'
    ? getMainProductVariantById(mainProduct, activeMainProductVariantId)
    : getPendantProductVariantById(mainProduct, activePendantProductVaraintIds[active])

  if (!activeProductVariant) {
    console.warn('No active product variant found. Check that the activeMainProductVariantId and activePendantProductVaraintIds are set correctly.')
    return null
  }

  const imageUrls = activeProductVariant.metafields.gallery
  const title = activeProductVariant.metafields.title
  const subtitle = activeProductVariant.metafields.subtitle
  const descriptionHtml = activeProductVariant.metafields.description

  return (
    <div className={className}>
      <p className="flex justify-between gap-4">
        <Text>{title}</Text>
        <Text style="heading">{formatCentsToDollars(activeProductVariant.price)}</Text>
      </p>

      <div className="mt-2 flex justify-end gap-4">
        {subtitle && (
          <p>
            <Text className="italic text-subdued">{subtitle}</Text>
          </p>
        )}
        <Button className="ml-auto shrink-0" onClick={() => setMoreOpen((currentValue) => !currentValue)}>
          <Text style="button-quaternary-dark">{moreOpen ? 'Less' : 'More'} Details</Text>
        </Button>
      </div>

      {moreOpen && (
        <>
          <div className="overflow-x-auto">
            <ul className="mt-4 flex items-center gap-3">
              {imageUrls.map((url, index) => (
                <li key={index} className="shrink-0 overflow-hidden rounded-sm">
                  <img
                    className="h-[150px] w-[115px] object-cover"
                    src={url}
                    width="115"
                    height="150"
                    alt={`Photo of ${title}`}
                  />
                </li>
              ))}
            </ul>
          </div>

          <div className="Rte mt-4" dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
        </>
      )}
    </div>
  )
}